import { render, staticRenderFns } from "./CentroManagers.vue?vue&type=template&id=2aaff44e"
import script from "./CentroManagers.vue?vue&type=script&lang=js"
export * from "./CentroManagers.vue?vue&type=script&lang=js"
import style0 from "./CentroManagers.vue?vue&type=style&index=0&id=2aaff44e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports